import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Component({
  selector: 'app-infopanel',
  templateUrl: './infopanel.component.html',
  styleUrls: ['./infopanel.component.css']
})
export class InfopanelComponent implements OnInit {
  @Input() text: string;
  sanitized;
  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.sanitized = this._sanitizer.sanitize(SecurityContext.HTML, this.text);
  }
  update(){
    this.sanitized = this._sanitizer.sanitize(SecurityContext.HTML, this.text);
  }

}



// WEBPACK FOOTER //
// ./src/app/infopanel/infopanel.component.ts